import { motion } from 'framer-motion';
import ColorButton from '../components/ColorButton';
import '../styles/Home.scss';
import PlainButton from '../components/PlainButton';
import Contact from '../components/Contact';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import Skills from '../components/Skills';

function Home({ toggleMenu, isMenuOpen }) {
	return (
		<>
			<div className="Container">
				<div className="Wrapper">
					<Nav toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
					<div className="Home-container">
						<div className="Home-grid">
							<div className="Home-image"></div>
							<motion.div
								initial={{ opacity: 0, x: -50 }}
								whileInView={{ opacity: 1, x: 0 }}
								transition={{ duration: 0.8 }}
								viewport={{ once: true, amount: 0.3 }}
							>
								<div className="Home-hero-grid">
									<h1 className="Main-text">
										Hey, I’m Juliana Ifionu and I'm a Software Engineer
									</h1>
									<ColorButton text={'Contact me'} icon={true} />
								</div>
							</motion.div>
						</div>
						<hr className="Hr-first" />
						<Skills />

						<div className="About-outer-grid">
							{/* Profile Image */}
							<motion.div
								className="profile-image"
								initial={{ opacity: 0, x: -50 }}
								whileInView={{ opacity: 1, x: 0 }}
								transition={{ duration: 0.6 }}
								viewport={{ once: true, amount: 0.3 }}
							></motion.div>

							{/* Text Section */}
							<motion.div
								className="About-inner-grid"
								initial={{ opacity: 0, x: 50 }}
								whileInView={{ opacity: 1, x: 0 }}
								transition={{ duration: 0.6, delay: 0.2 }}
								viewport={{ once: true, amount: 0.3 }}
							>
								<hr className="First" />
								<div className="Main-text-wrap">
									<h1 className="Main-text">About Me</h1>
								</div>
								<p className="Paragraph-text">
									I’m a Software Engineer who loves creating applications that
									are fast, secure, and built to scale, all while making sure
									the experience feels effortless for the users.
								</p>
								<PlainButton text={'Go to portfolio'} />
								<hr className="Second" />
							</motion.div>
						</div>

						<Contact />
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
}

export default Home;
